import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({ 
  tableFont: {
    fontSize: '18px'
  },
}));
    
